import React, { useState, useEffect } from "react";
import "../../components/ShopItemsOwner/shopItems.css";
import { Col, Row, Button, Container, Pagination } from "react-bootstrap";
import { images } from "../../constants";
import RedoIcon from "@mui/icons-material/Redo";
import { useNavigate } from "react-router-dom";
import { getAsset } from "../../helpers/helper";
import dummyezi from "../../assets/images/dummy/dummyezi.png";
import GradeIcon from "@mui/icons-material/Grade";
const SalesPromotion = ({
  salepromotion,
  urlPass,
  shopid,
  setShows,
  setItemid,
  setShowmodal,
  newItemdata,
  setShow,
  UserShopView,
  salespromotion,
  itemdata,
  filtersales,
  handleShareClick,
}) => {
  const navigate = useNavigate();
  const [dummyItems, setDummyItems] = useState(100); // Start with 100 dummy items
  const [currentPage, setCurrentPage] = useState(1); // Track current page
  const itemsPerPage = 50; // Limit to 50 items (items + dummy) per page

  // Determine which data source to use: filtersales or salepromotion/salespromotion
  const items = filtersales || salepromotion || salespromotion || [];

  // Calculate total items (data + dummy items) and pages
  const totalItems = Math.max(items?.length || 0, 100); // At least 100 items (items or dummy)
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Calculate the items to display for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = items?.slice(indexOfFirstItem, indexOfLastItem);
  const currentDummyCount = Math.max(0, 100 - (currentItems?.length || 0));

  useEffect(() => {
    // Adjust number of dummy items based on items length
    setDummyItems(Math.max(0, 100 - (items?.length || 0))); // Total dummy items
  }, [items]);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0); // Scroll to top on page change
  };

  // Combine items and dummy items
  const renderItems = () => {
    const renderedItems = [];
    const dummyImageSources = [
      { src: images.SelecteziLogo, key: "dummy-1" }, // Replace with actual placeholder if needed
      { src: images.SelecteziLogo, key: "dummy-2" }, // Replace with actual placeholder if needed
    ];

    // Add actual items
    if (currentItems?.length > 0) {
      currentItems.forEach((Items) => {
        renderedItems.push(
          <div className="col-lg-4 col-xl-3 col-md-6 p-2" key={Items?._id}>
            <div className="border_2">
              <div>
                <div className="fix-img position-relative">
                  <p className="mb-0 position-absolute p-1 bg-danger text-white font_12">
                    {Items?.salespromotion}
                  </p>
                  <img
                    className="c_img"
                    src={
                      (Items?.images && Items?.images[0]) ||
                      (Items?.image && Items?.image[0])
                        ? getAsset(
                            Items?.images ? Items?.images[0] : Items?.image[0],
                          )
                        : dummyezi
                    }
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = dummyezi;
                    }}
                    alt=""
                    crossOrigin="anonymous"
                  />
                </div>
                <Row className="align-items-center">
                  <Col lg={6} md={5} className="pe-0">
                    <div className="pt-1 ms-2">
                      <p className="mb-0 ps-2 pe-2 items-card-font fw-bold">
                        {Items?.itemname.slice(0, 7)}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6} md={7} className="ps-0 pe-4">
                    <div>
                      {newItemdata && newItemdata.length > 0 ? (
                        <p className="mb-0 ps-2 pe-2 stock mt-2 me-2">
                          {Items?.stock} stock
                        </p>
                      ) : (
                        <p className="mb-0 ps-2 labelText fw-bold pt-1 ms-2 ms-lg-1 text-end">
                          Qty ({Items?.quantity})
                        </p>
                      )}
                    </div>
                  </Col>
                </Row>
                <div className="d-flex justify-content-between align-items-center ps-2 pe-2">
                  <p className="mb-0 pt-1 items-card-font font-blue ms-2">
                    <span style={{ color: "black" }}>Price:</span>&nbsp;
                    {Items?.currency?.slice(0, 3)}&nbsp;{Items?.price}
                  </p>
                  <div style={{ color: "black", fontSize: "12px" }}>
                    <b>
                      <GradeIcon
                        style={{
                          fontSize: "medium",
                          color: "#FFE507",
                        }}
                      />
                      ({Items?.rating ? Number(Items.rating).toFixed(1) : "0.0"}
                      )
                    </b>
                  </div>
                </div>
                {newItemdata && newItemdata.length > 0 ? (
                  ""
                ) : (
                  <div className="row align-items-center">
                    <Col lg="6" xs="6" md="6" sm="6" className="pe-0">
                      <h6 className="items-card-font ms-3 mb-0">
                        Orders ({Items?.orders || 0})
                      </h6>
                    </Col>
                    <Col lg="6" className="text-center">
                      <button
                        className="text-white bg-blue share_font item-share-btn"
                        onClick={() => {
                          if (handleShareClick) {
                            handleShareClick(Items._id);
                          } else {
                            setShowmodal(true);
                          }
                        }}
                      >
                        Share
                        <RedoIcon className="share_icon_f" />
                      </button>
                    </Col>
                  </div>
                )}
                <div className="d-flex justify-content-around mb-2 mt-1">
                  <p
                    className={
                      newItemdata && newItemdata.length > 0
                        ? "mb-0 ps-lg-4 pe-lg-4 view_btn-User"
                        : "mb-0 view-btn btn-primary text-center ms-1 me-1 mt-1"
                    }
                    onClick={() => {
                      newItemdata && newItemdata.length > 0
                        ? (() => {
                            UserShopView(Items?._id);
                            setShow(true);
                          })()
                        : navigate(`${urlPass}/${shopid}/${Items._id}`);
                    }}
                  >
                    View
                  </p>
                  {newItemdata && newItemdata.length > 0 ? (
                    ""
                  ) : (
                    <Button
                      className="mb-0 view-btnone text-white text-center ms-1 me-1 mt-1"
                      variant="danger"
                      onClick={() => {
                        setShows(true);
                        setItemid(Items._id);
                      }}
                    >
                      Delete
                    </Button>
                  )}
                </div>
                {newItemdata && newItemdata.length > 0 ? (
                  <div className="margin-Boxes">
                    <Row className="row bg-blue">
                      <Col lg={6} md={4} className="p-0">
                        <div className="border-end cursor">
                          <p className="mb-0 ps-1 d-flex justify-content-center p-1">
                            <img className="w-img-card" src={images?.Mail} />
                            <span className="btns text-white ps-1">
                              Message
                            </span>
                          </p>
                        </div>
                      </Col>
                      <Col lg={6} md={4} className="p-0">
                        <div className="cursor">
                          <p className="mb-0 ps-1 d-flex justify-content-center p-1">
                            <img className="w-img-card" src={images?.Phone} />
                            <span className="btns text-white ps-1">Call</span>
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>,
        );
      });
    }

    // Add dummy items
    Array.from({ length: currentDummyCount }).forEach((_, index) => {
      const dummy = dummyImageSources[index % dummyImageSources.length];
      renderedItems.push(
        <div
          className="col-lg-4 col-xl-3 col-md-6 p-2"
          key={`dummy-${index}-${indexOfFirstItem}`}
        >
          <div className="border_2 rounded">
            <div>
              <img
                className="c_img"
                src={dummyezi}
                alt="Dummy Item"
                style={{ objectFit: "cover", height: "100%", width: "100%" }}
              />

              <div className="text-center pt-2 pb-2">
                <p className="mb-0 items-card-font fw-bold">
                  Post item to see here
                </p>
              </div>
            </div>
          </div>
        </div>,
      );
    });

    return renderedItems;
  };

  return (
    <Container>
      <div className="shop-scroll noscroll">
        <div className="items_scroll noscroll">
          <div className="row ps-2 pe-2">
            {items?.length > 0 || currentDummyCount > 0 ? (
              <>
                {renderItems()}
                {currentItems?.length === 0 && currentDummyCount === 0 && (
                  <h4 className="text-center">No items found</h4>
                )}
              </>
            ) : (
              <h4 className="text-center">No items found</h4>
            )}
          </div>
          {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-4">
              <Pagination>
                <Pagination.Prev
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                />
                {Array.from({ length: totalPages }, (_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === currentPage}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
                <Pagination.Next
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                />
              </Pagination>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default SalesPromotion;
